import React, { useState } from 'react';
import { Check, Star, Award } from 'lucide-react';
import { pricingPlans } from '../mockData';
import UniversalPopupForm from './UniversalPopupForm';

const PricingSection = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <>
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Affordable Trademark Registration Packages
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Choose the perfect plan for your Canadian trademark needs. All packages include expert guidance and CIPO filing support.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {pricingPlans.map((plan, index) => (
              <div
                key={index}
                className={`relative bg-white rounded-2xl shadow-lg border-2 overflow-hidden transform transition-all duration-300 hover:scale-105 ${
                  plan.recommended
                    ? 'border-brand-600 shadow-blue-200 lg:scale-105'
                    : plan.badge === 'Best Seller'
                    ? 'border-green-600 shadow-green-200'
                    : 'border-gray-200 hover:border-blue-400'
                }`}
              >
                {plan.badge && (
                  <div className={`absolute top-0 left-0 right-0 text-white text-center py-2 text-sm font-semibold ${
                    plan.recommended 
                      ? 'bg-gradient-to-r from-brand-600 to-brand-800'
                      : 'bg-gradient-to-r from-green-600 to-green-800'
                  }`}>
                    {plan.recommended ? (
                      <>
                        <Star className="w-4 h-4 inline mr-1" />
                        {plan.badge}
                      </>
                    ) : (
                      <>
                        <Award className="w-4 h-4 inline mr-1" />
                        {plan.badge}
                      </>
                    )}
                  </div>
                )}

                <div className={`p-6 ${plan.badge ? 'pt-14' : ''}`}>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                  <div className="mb-4">
                    <span className="text-4xl font-bold text-brand-600">{plan.price}</span>
                  </div>
                  <p className="text-sm text-gray-600 mb-6">{plan.note}</p>

                  <div className="h-48 overflow-y-auto mb-6 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                    <ul className="space-y-3 pr-2">
                      {plan.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start">
                          <Check className="w-5 h-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                          <span className="text-sm text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <button
                    onClick={() => setIsPopupOpen(true)}
                    className={`w-full font-semibold py-3 px-6 rounded-lg transition-all duration-200 ${
                      plan.recommended || plan.badge === 'Best Seller'
                        ? 'bg-gradient-to-r from-brand-600 to-brand-800 text-white hover:from-brand-700 hover:to-brand-900 shadow-md'
                        : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                    }`}
                  >
                    Get Started
                  </button>

                  <p className="text-xs text-gray-500 text-center mt-4">{plan.footnote}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <p className="text-sm text-gray-600">
              *CIPO filing fees are set by the Canadian Intellectual Property Office and are paid directly during the application process.
            </p>
          </div>
        </div>
      </section>

      <UniversalPopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
};

export default PricingSection;
